export default __webpack_public_path__ + "static/media/check2.5e0d9af9.svg";